<template>
  <page-option
    :disable-add="!checkAccess('basemap.create')"
    overflow-hidden
    @click:add="onCreateItem()"
  >
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-map</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.basemap.name') }}</div>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
        use-grid
        use-scroll-load
        use-top
      >
        <template #grid-item="{ item }">
          <basemap-item
            :item="item"
            class="full-width full-height"
            @click:delete="onDeleteItem"
            @click:update="onUpdateItem"
            @click:setDefault="setDefault"
          />
        </template>
      </base-serve-table>
    </v-sheet>
    <BasemapDialog ref="dialog" @reset="onReset" />
  </page-option>
</template>

<script>
import { API_BASEMAP } from '@api'
import { ConfirmBuilder } from '@utils'
import { EDIT_TYPE } from '@constant'
import BasemapDialog from './basemap-dialog.vue'
import BasemapItem from './basemap-item.vue'
export default {
  mixins: [],
  components: {
    BasemapDialog,
    BasemapItem,
  },
  props: {
    option: { type: Object, default: () => ({ params: { sort: '-title' } }) },
  },
  data: (vm) => ({
    default_params: {},
    params: { search: '', inactive: null },
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'title',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
    ],
    loading: false,
  }),
  watch: {},
  computed: {
    api() {
      return API_BASEMAP
    },
  },
  created() {},
  mounted() {},
  methods: {
    async setDefault(item) {
      await API_BASEMAP.setDefault(item.id)
      this.onReset()
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await API_BASEMAP.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onCreateItem() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
  },
}
</script>
